import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class WifiNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Wi-Fi Connected';
        this.id = 'node_wifi';
        this.linkedFeature = 'wifi';
        this.requirements = ['WM2000'];
        this.outputs = [
            {
                name: 'Wi-Fi Connected',
                portId: 'wifi_connected',
                params: [],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const wifiFeature = project.getFeature('wifi');

        const links = project.getNodeLinks(this, 'wifi_connected');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: project.getNetworkConnectedLocation('PL_SOCK_INTERFACE_WLN'),
                blockType: BlockType.CODE,
                template: `
    '****${link.getSourceId()}****'`,
            });
        }

        return blocks;
    }
}
